<template>
    <div :class="layoutClass">
        <slot></slot>
        <layout-portal></layout-portal>
        <layout-portal name="modals-sub"></layout-portal>
        <layout-portal name="modals-sub2"></layout-portal>
        <layout-portal name="submenus"></layout-portal>
    </div>
</template>

<script>
    import LayoutPortal from './Portal.vue';

    export default {
        components: {
            LayoutPortal,
        },
        props: {
            layoutClass: {
                type: String,
                default: 'h-screen'
            }
        }
    }
</script>
